import { Injectable } from '@angular/core';

export enum LogLevel {
  None = 0,
  Info = 1,
  Verbose = 2,
  Warn = 3,
  Error = 4,
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  log(msg: string): void {
    this.logWith(LogLevel.None, msg);
  }

  info(msg: string): void {
    this.logWith(LogLevel.Info, msg);
  }

  warn(msg: string): void {
    this.logWith(LogLevel.Warn, msg);
  }

  error(msg: string, stackTrace: string): void {
    this.logWith(LogLevel.Error, msg, stackTrace);
  }

  private logWith(level: LogLevel, msg: string, error: string | null = null): void {
    if (level <= LogLevel.Error) {
      switch (level) {
        case LogLevel.None:
          return console.log(msg);
        case LogLevel.Info:
          return console.info('%c' + msg, 'color: #6495ED');
        case LogLevel.Warn:
          return console.warn('%c' + msg, 'color: #FF8C00');
        case LogLevel.Error:
          return console.error('%c' + msg, 'color: #DC143C', error);
      }
    }
  }
}
